import CloseIcon from '@mui/icons-material/Close';
import { Grid, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { styled, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import LoaderHavePopup from 'src/component-project/loader_have_popup';
import ChessBoardSelectCell from 'src/component-project/TableSelectedUser/ChessBoardSelectCell';
import ComboBox from 'src/components/Input/ComboBox';
import TextInput from 'src/components/Input/TextInput';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import ButtonAction from '../../../components/Button.js/SaveButton';
import NumberInput from '../../../components/Input/NumberInput';
import Loader from '../../../components/loader/loader';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const AdminReviewDevice = ({ visible = false, callBackFunct, setVisible, data, idPermission }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [flagProcess, setFlagProcess] = useState(false);
    const [quantity, setQuantity] = useState(0);
    const [dataDrawer, setDataDrawer] = useState([]);
    const [dataCell, setDataCell] = useState([]);
    const [selectDrawer, setSelectDrawer] = useState(0);
    const [selectedCell, setSelectedCell] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const isHandledRef = useRef(false);
    const flagRef = useRef(false);
    const [selectedDepreciation, setSelectedDepreciation] = useState(null);
    const [depreciationValue, setDepreciationValue] = useState(0);
    const cabinetAtAccount = glb_sv.getLocalStorageCabinet('cabinet');

    const depreciationOptions = [
        { label: 'Loại 1 (70%)', value: 70 },
        { label: 'Loại 2 (50%)', value: 50 },
        { label: 'Loại 3 (25%)', value: 25 },
        { label: 'Khác (Nhập tay)', value: -1 },
    ];

    const user = glb_sv.userInfo;
    const isAdmin = (user?.group_user === '1' || user?.group_user === '2') && data?.status === '5';

    useEffect(() => {
        try {
            setIsOpen(false);
            setDataDrawer([]);
            setDataCell([]);
            setSelectedCell(null);
            setQuantity(data?.qty_change_request || data?.qty);
            setDepreciationValue(data?.depreciation_rate);
            setSelectedDepreciation(
                depreciationOptions?.find((ele) => ele.value === data?.depreciation_rate)?.value || -1
            );
            if (cabinetAtAccount?.id && visible && data?.device_cd) {
                isHandledRef.current = false;
                getDataDrawer(cabinetAtAccount?.id);
            }
        } catch (e) {}
    }, [visible]);

    useEffect(() => {
        try {
            if (selectDrawer !== 0 && visible) {
                setSelectedCell(null);
                getAllCell(cabinetAtAccount?.id, selectDrawer);
            }

            if (selectDrawer === 0 && visible) {
                setDataCell([]);
                setSelectedCell(null);
            }
        } catch (e) {}
    }, [selectDrawer, data?.id, visible]);

    useEffect(() => {
        return () => {
            clearIntervalCheckStatusCell();
        };
    }, []);

    const timeOutFunctCabinet = (reqInfo) => {
        flagRef.current = false;
        setFlagProcess(false);
    };
    const getDataDrawerResult = (reqInfoMap, message) => {
        setFlagProcess(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const drawerData = [...message.proc_data.rows[0].o_1].filter((ele) => ele.block_status === '1');
            const drawerDataSuggest = message.proc_data?.suggest_drawer;
            drawerData.map((ele) => {
                setDataDrawer((prev) => {
                    if (prev.some((item) => item.value === ele.id)) return prev;

                    return [
                        ...prev,
                        {
                            label: ele.drawer_nm,
                            value: ele.id,
                            lc: ele.drawer_lc,
                        },
                    ];
                });
            });
            setSelectDrawer(data?.drawer_id);
        }
    };

    const getDataDrawer = useCallback(
        (id) => {
            const InVal = [id];
            sendRequest(serviceList.getAlldrawerSp, InVal, getDataDrawerResult, true, timeOutFunct, 15000);
        },
        [data?.cabinet_id, visible]
    );

    const getAllCell = useCallback(
        (id_capinet, id_drawer) => {
            const InVal = [idPermission, id_capinet, id_drawer];
            sendRequest(serviceList.getAllbox, InVal, getDataCellResult, true, timeOutFunct, 15000);
        },
        [data?.cabinet_id, selectDrawer, data?.id]
    );

    const getDataCellResult = (reqInfoMap, message) => {
        setFlagProcess(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDataCell([...message.proc_data.rows[0].o_1]);
            setSelectedCell([...message.proc_data.rows[0].o_1].find((ele) => ele.id === data.cell_id));
        }
    };
    // region send request grinding device
    const handleClick = useCallback(() => {
        if (depreciationValue === null || depreciationValue === undefined || depreciationValue < 0) {
            toast.error(t('not_empty_depreciation'));
            return;
        }
        if (isHandledRef.current) return;
        clearIntervalCheckStatusCell();
        setFlagProcess(true);
        isHandledRef.current = true;
        const InVal = [data?.id, selectedCell?.id, depreciationValue, quantity];
        sendRequest(serviceList.adminPutCheckDepreciation, InVal, actionResult, true, timeOutFunct, 600000);
        // actionResult("aaaa", {proc_status: 1, proc_message: "fininse"})
    }, [data, selectedCell, depreciationValue]);

    const actionResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            closeCell();
        }
    };
    // region open cell
    const openCell = (data) => {
        setFlagProcess(true);
        let service = serviceList.openCellIOT;
        const drawer_lc_select = dataDrawer.find((ele) => ele.value === (selectDrawer || data?.drawer_id))?.lc;
        let inpuVal = [
            cabinetAtAccount?.cabinet_cd,
            drawer_lc_select,
            selectedCell.cell_lc.row,
            selectedCell.cell_lc.column,
        ];

        if (cabinetAtAccount?.cabinet_type !== 'round') {
            service = serviceList.openCellIOT;
            inpuVal = [
                cabinetAtAccount?.cabinet_cd,
                drawer_lc_select,
                selectedCell.cell_lc.row,
                selectedCell.cell_lc.column,
            ];
        } else {
            service = serviceList.openCellIOTCabinetV2;
            inpuVal = [cabinetAtAccount?.cabinet_cd, drawer_lc_select, selectedCell.cell_lc.row, selectedCell.column];
        }
        sendRequest(service, inpuVal, openCellResult, true, timeOutFunct, 30000, 0);
    };

    const openCellResult = (reqInfoMap, message) => {
        console.log('reqInfoMap', reqInfoMap['input_param']);

        if ((message['proc_status']?.toString() || '0') === '0') {
            // closeCell();
            toast.error('Error: ' + message['proc_message']);
        } else {
            setFlagProcess(false);
            setIsOpen(true);
            // handleClick();
            const input_param = reqInfoMap['input_param'];

            handleIntervalCheckStatusCell(input_param[0], input_param[1], input_param[2]);
        }
    };

    // region closeCell
    const closeCell = () => {
        let service = serviceList.closeCellIOT;
        clearIntervalCheckStatusCell();
        const drawer_lc_select = dataDrawer.find((ele) => ele.value === ele.id)?.lc;
        let inpuVal = [
            cabinetAtAccount?.cabinet_cd,
            drawer_lc_select,
            selectedCell.cell_lc.row,
            selectedCell.cell_lc.column,
        ];
        if (cabinetAtAccount?.cabinet_type !== 'round') {
            service = serviceList.closeCellIOT;
            inpuVal = [
                cabinetAtAccount?.cabinet_cd,
                drawer_lc_select,
                selectedCell.cell_lc.row,
                selectedCell.cell_lc.column,
            ];
        } else {
            service = serviceList.closeCellIOTCabinetV2;
            inpuVal = [cabinetAtAccount, drawer_lc_select, selectedCell.cell_lc.row, selectedCell.column];
        }
        sendRequest(service, inpuVal, closeCellResult, true, timeOutFunct, 30000, 0);
        // console.log('inpuValClose: ', inpuVal);
        // console.log('serviceListClose: ', service);
    };

    // region closeCellResult
    const closeCellResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
        } else {
            setIsOpen(false);
            setFlagProcess(false);
            callBackFunct && callBackFunct();
            isHandledRef.current = false;
        }
        clearIntervalCheckStatusCell();
    };

    // region checkStatusCell START
    const checkIntervalCheckStatusCell = useRef(null);
    const checkStatusCellFlag = useRef(false);
    const handleIntervalCheckStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        checkIntervalCheckStatusCell.current = setInterval(() => {
            checkStatusCell(cabinet_cd, drawer_id, cell_address);
        }, 3000);
    };
    const clearIntervalCheckStatusCell = () => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        clearInterval(checkIntervalCheckStatusCell.current);
    };
    const checkStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        if (!cabinet_cd || !drawer_id || !cell_address || checkStatusCellFlag.current) return;
        checkStatusCellFlag.current = true;
        const inpuVal = [cabinet_cd, drawer_id, cell_address];
        sendRequest(
            serviceList.checkStatusCell,
            inpuVal,
            checkStatusCellResult,
            true,
            checkStatusCellTimeOut,
            10000,
            0
        );
    };
    const checkStatusCellResult = (reqInfoMap, message) => {
        checkStatusCellFlag.current = false;
        console.log(
            'checkStatusCellResult',
            (message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1'
        );
        if ((message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1') {
            clearIntervalCheckStatusCell();
            if (!data?.cell_id && !cabinetAtAccount?.id && !data?.drawer_id) {
                if (!isHandledRef.current || !flagProcess) {
                    handleClick();
                }
            } else {
                closeCell();
            }
        }
    };
    const checkStatusCellTimeOut = (reqInfo) => {
        checkStatusCellFlag.current = false;
        setFlagProcess(false);
        toast.error(t('error.request_timeout'));
    };

    const timeOutFunct = (reqInfo) => {
        setFlagProcess(false);
        setIsOpen(false);
        toast.error(t('error.time_out'));
    };

    const handleQuantityChange = (val) => {
        if (val <= data.qty) {
            setQuantity(val);
        } else {
            setQuantity(data.qty);
        }
    };

    const handleDepreciationChange = (e) => {
        setSelectedDepreciation(e);
        if (e && e.value !== -1) {
            setDepreciationValue(e.value);
        } else {
            setDepreciationValue(0); // Reset về 0 nếu chọn nhập tay để người dùng nhập
        }
    };

    useEffect(() => {
        if (depreciationValue) {
            setSelectedCell(null);
        }
    }, [depreciationValue]);

    const getNewDeviceCd = () => {
        if (!data?.device_cd) return '';

        const base = data?.device_cd.replace(/_DG\d{2}.*$/, '');
        if (!depreciationValue || depreciationValue == 0) return base;

        return `${base}_DG${depreciationValue.toString().padStart(2, '0')}`;
    };
    return (
        <BootstrapDialog
            fullScreen={fullScreen}
            open={visible}
            aria-labelledby="customized-dialog-title"
            PaperProps={{ component: 'div' }}
        >
            <BootstrapDialogTitle
                onClose={() => {
                    setVisible(!visible);
                }}
                id="customized-dialog-title"
            >
                {t('depreciation_assessment')} <br /> {t('name_device')}: {data?.device_cd}_{data?.device_nm}
            </BootstrapDialogTitle>
            <Loader loading={flagProcess || isHandledRef.current} />
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item style={{ width: '100%' }} xl={12} md={12} sm={12}>
                        <NumberInput
                            label={t('amount')}
                            valueChange={quantity}
                            size="medium"
                            getValue={handleQuantityChange}
                            disabled={true}
                        />
                    </Grid>

                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%', marginTop: 7 }}>
                        <ComboBox
                            label="Chọn % khấu hao"
                            sizeCbb="medium"
                            displayLabel="label"
                            valueSelect={selectedDepreciation}
                            valueEqual="value"
                            getValue={handleDepreciationChange}
                            selectOption={depreciationOptions}
                        />
                    </Grid>
                    {selectedDepreciation?.value === -1 && (
                        <Grid item xl={12} md={12} sm={12} style={{ width: '100%', marginTop: 7 }}>
                            <NumberInput
                                label="Nhập % khấu hao tùy chỉnh"
                                valueChange={depreciationValue}
                                size="medium"
                                getValue={(val) => {
                                    let num = Number(val);
                                    if (isNaN(num)) num = 0;
                                    let limitedVal = Math.min(Math.max(0, num), 100);
                                    setDepreciationValue(limitedVal);
                                }}
                                In
                            />
                        </Grid>
                    )}

                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%', marginTop: 7 }}>
                        <TextInput
                            label={t('choose_cabinet')}
                            valueChange={cabinetAtAccount?.cabinet_nm}
                            disabled
                            size="medium"
                            autoFocus
                        />
                    </Grid>
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%', marginTop: 7 }}>
                        <ComboBox
                            label={t('choose_drawer')}
                            sizeCbb="medium"
                            displayLabel="label"
                            valueSelect={dataDrawer.find((ele) => ele.value === selectDrawer)}
                            valueEqual="value"
                            getValue={(e) => setSelectDrawer(e?.value || 0)}
                            selectOption={dataDrawer}
                            required
                        />
                    </Grid>

                    {dataCell.length > 0 && (
                        <>
                            <Typography variant="h5" sx={{ mt: 2, textAlign: 'center', width: '100%' }}>
                                {t('select_empty_cell_or_cell_have_this_device')}
                            </Typography>
                            <Typography
                                variant="caption"
                                sx={{
                                    textAlign: 'center',
                                    display: 'block',
                                    fontStyle: 'italic',
                                    width: '100%',
                                    color: '#adb1b5',
                                }}
                            >
                                {t('cell_have_lock')}
                            </Typography>
                            <ChessBoardSelectCell
                                typeCabinet={data?.cabinet_type}
                                // cell_id_request={data?.cell_id}
                                onSelect={(pos) => {
                                    if (!isAdmin && data?.status !== '5' && data?.status !== '7') {
                                        setSelectedCell(pos);
                                    }
                                }}
                                dataCell={dataCell}
                                selectedCell={selectedCell}
                                device_cd={
                                    depreciationValue == 0 || data.cell_qty == 0 ? getNewDeviceCd() : getNewDeviceCd()
                                }
                                just_device_cd={true}
                                qty={-1}
                            />
                        </>
                    )}
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction
                    onClick={() => {
                        setVisible(!visible);
                    }}
                    type={'cancel'}
                    title={t('cancel')}
                />
                {!isOpen ? (
                    <ButtonAction
                        onClick={() => {
                            openCell(data);
                            //
                        }}
                        type={'confirm'}
                        icon="send"
                        title={t('open_cell_input')}
                    />
                ) : (
                    <ButtonAction
                        onClick={() => {
                            handleClick();
                        }}
                        type={'confirm'}
                        icon="send"
                        title={t('confrim_success')}
                    />
                )}
            </DialogActions>
        </BootstrapDialog>
    );
};

export default AdminReviewDevice;
